export default "__VITE_ASSET__Cyjgbz3j__"